@if(loader){
<app-loader></app-loader>
}

<p-card [header]="(isEdit===true)?'View Dispatch Order':'Create Dispatch Order' ">

    <form [formGroup]="createOrderForm">

        <!-- <div class="col"> -->

        <div class="field col-12 flex justify-content-between align-items-center">
            <div class="flex justify-content-start">

                <p-button label="Update" severity="info" (click)="showSaveOptionsPopup()" icon="pi pi-save"
                    size="small"></p-button>

                @if(isEdit){
                <p-button label="Move To Invoice" icon="pi pi-file-export" (click)="movetoInvoice()" severity="info"
                    size="small" class="p-button-sm ml-2"></p-button>
                }
                <p-button label="Linked Files" icon="pi pi-paperclip" size="small" (click)="openLinkedFiles()"
                    class="p-button-sm ml-2"></p-button>
                <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" (click)="Cancel()"
                    class="p-button-sm ml-2"></p-button>

            </div>

            <div>
                <label class="block label-required" style="font-weight: bold;">Required Field</label>
            </div>
        </div>

        <!-- </div> -->

        <div class="grid mt-3">


            <div class="col">

                <div class="field text-left" style="display: flex; flex-direction: column; align-items: flex-start;">
                    <label for="website" class="label-required display">Order No</label>
                    <div style="display: flex; align-items: center;">
                        <input pInputText formControlName="OrderNo" placeholder="e.g 89098" type="text"
                            [readonly]="isEdit || !this.createOrderForm.controls.manualEntry.value || products.length > 0"
                            class="w-full p-inputtext-sm"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.OrderNo.errors }" />
                        @if (!isEdit) { <div style="margin-left: 10px;">
                            <p-checkbox formControlName="manualEntry" *ngIf="products.length == 0"
                                (onChange)="manualEntry()" [binary]="true" label="Manual Entry"
                                value="true"></p-checkbox>
                        </div>
                        }
                    </div>
                </div>

                <div class="field text-left">
                    <label for="website" class="label-required display">{{unitLabel}}</label>
                    <p-autoComplete formControlName="warehouse" [dropdown]="(products.length > 0)? false : true"
                        [readonly]="products.length > 0" (onSelect)="setWarehouse($event)"
                        [suggestions]="warehouseDropdown" (completeMethod)="getWarehouse()" field="warehouseCode"
                        placeholder="Search {{unitLabel}}" styleClass="w-full"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.warehouse.errors }">
                        <ng-template let-item pTemplate="item">
                            <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
                        </ng-template>
                    </p-autoComplete>
                </div>

                <div class="field text-left">
                    <label for="supplyType" class="label-required display">Supply Type</label>
                    <input pInputText readonly formControlName="supplyType" class="w-full p-inputtext-sm"
                        (keydown)="onKeydown($event,products)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.supplyType.errors}" />
                </div>

                <div class="field text-left flex align-items-center gap-3">

                    <div *ngIf="createOrderForm.get('isLUT')?.value">
                        <p-checkbox formControlName="isLUT" [binary]="true" label="Supply under LUT (No GST)"
                            [readonly]="true">
                        </p-checkbox>
                    </div>



                    <div *ngIf="createOrderForm.get('isRCM')?.value">
                        <p-checkbox formControlName="isRCM" [binary]="true" label="Reverse Charge (RCM)"
                            [readonly]="true">
                        </p-checkbox>
                    </div>

                </div>

                <div class="field text-left">
                    <div *ngIf="isExportOrSEZ()" class="field">

                        <label>Export Type</label>
                        <div class="p-2 border-round surface-100">
                            {{ getExportTypeLabel() }}
                        </div>

                    </div>

                </div>

                <div class="field text-left">
                    <label for="saleserson" class="label-required display"> Salesperson</label>
                    <div class="p-inputgroup p-lookup">
                        <input pInputText formControlName="saleserson" readonly class="w-full p-inputtext-sm"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.SalespersonCode.errors }" />
                        <button type="button" [disabled]="products.length > 0" pButton pRipple
                            (click)="showSalesperson()" icon="pi pi-search" styleClass="p-button-warn"></button>
                    </div>
                </div>



            </div>

            <div class="col">

                <div class="field text-left">
                    <label for="BillToCustomerCode" class="label-required display">Bill To Customer Code</label>
                    <span class="p-fluid">
                        <div style="display: flex;">
                            <p-autoComplete formControlName="BillToCustomerCode" [readonly]="products.length > 0"
                                (onSelect)="setBillTo($event)" [suggestions]="BillTocustomerList"
                                (completeMethod)="autosearchBilltoCustomer($event)" field="customerCode"
                                styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.BillToCustomerCode.errors }">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.customerCode}} - {{item.customerName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <button type="button" pButton [disabled]="products.length > 0" pRipple
                                (click)="showBillToCustomerDialog()" icon="pi pi-search" styleClass="p-button-warn"
                                style="margin-left: 10px;"></button>
                        </div>
                    </span>
                </div>

                <div class="field text-left">
                    <label for="BillToCustomer">Bill To Customer Name</label>
                    <input pInputText readonly formControlName="BillToCustomer" class="w-full p-inputtext-sm" />
                </div>



                <div class="field text-left">
                    <label for="BillToCustomerAddress">Address</label>
                    <input pInputText readonly formControlName="BillToCustomerAddress" class="w-full p-inputtext-sm" />
                </div>

                <div class="field text-left">
                    <label for="orderDate">Order Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="orderDate"
                            [showIcon]="true" placeholder="Select Date"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.orderDate.errors }"
                            styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                    </div>
                    <!-- <small *ngIf="submitted && formControls.orderDate.errors" id="name-error"
                          class="text-red-500">Required field.</small> -->
                </div>

                <div class="field text-left">
                    <label for="requestedDate">Requested Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="requestedDate"
                            [showIcon]="true" placeholder="Select Date"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.requestedDate.errors }"
                            styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                    </div>
                    <!-- <small *ngIf="submitted && formControls.requestedDate.errors" id="name-error"
                          class="text-red-500">Required field.</small> -->
                </div>

            </div>

            <div class="col">

                <div class="field text-left">
                    <label for="ShipToCustomerCode" class="label-required display">Ship To Customer Code</label>
                    <span class="p-fluid">
                        <div style="display: flex;">
                            <p-autoComplete formControlName="ShipToCustomerCode" [readonly]="products.length > 0"
                                (onSelect)="setShipTo($event)" [suggestions]="ShipTocustomerList"
                                (completeMethod)="autosearchShiptoCustomer($event)" field="customerCode"
                                styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ShipToCustomerCode.errors }">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.customerCode}} - {{item.customerName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <button type="button" pButton [disabled]="products.length > 0" pRipple
                                (click)="openShipToCustomerLookup()" icon="pi pi-search" styleClass="p-button-warn"
                                style="margin-left: 10px;"></button>
                        </div>
                    </span>
                </div>

                <div class="field text-left">
                    <label for="ShipToCustomer">Ship To Customer Name</label>
                    <input pInputText formControlName="ShipToCustomer" readonly class="w-full p-inputtext-sm" />
                </div>

                <div class="field text-left">
                    <label for="ShipToCustomerAddress">Address</label>
                    <input pInputText readonly formControlName="ShipToCustomerAddress" class="w-full p-inputtext-sm" />
                </div>

                <div class="field text-left" *ngIf="createOrderForm.get('POS')?.value">
                    <label>Place of Supply (POS)</label>
                    <input pInputText formControlName="POSDisplay" readonly class="w-full" />
                </div>

                <div class="field text-left" *ngIf="createOrderForm">

                    <label for="Status">Order Status</label>
                    <div>
                        <p-dropdown [options]="statusDropdown" formControlName="Status" optionLabel="label"
                            optionValue="value" styleClass="w-full">
                        </p-dropdown>

                        <!-- <p-dropdown formControlName="Status" [options]="statusDropdown" styleClass="w-full" placeholder="Select status"
                                (onChange)="onStatusChange($event)"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.Status.errors }">
                            </p-dropdown> -->
                    </div>
                </div>

            </div>

        </div>

        <p-tabView [(activeIndex)]="activeIndex">

            <p-tabPanel header="Order Lines">
                <!-- <div class="grid" style="margin-bottom: -0.5rem !important;">

                        <div class="col" #productCodeAutoComplete>
                            <div class="field text-left " style="display: flex; align-items: center;">

                                <p-image src="./assets/no-image.jpg" alt="product" width="40" [preview]="true"></p-image>

                                <p-autoComplete formControlName="productCode" placeholder="Product Code"
                                    [style]="{'height':'45px'}" (onSelect)="setProduct($event)"
                                    [suggestions]="filterProductList" (completeMethod)="autosearchProduct($event)"
                                    field="customerCode">
                                    <ng-template let-item pTemplate="item" class="text-left">
                                        <span>{{item.productCode}} - {{item.productName}}</span>
                                    </ng-template>

                                </p-autoComplete>
                            </div>
                        </div>

                        <div class="col">
                            <input pInputText formControlName="productDescription" readonly placeholder="Description"
                                class="w-full p-inputtext-sm" />
                        </div>

                        <div class="col">
                            <div class="field text-left" style="display: flex; align-items: center;">
                                <span style="flex-grow: 1; margin-right: 10px;">
                                    <input pInputText type="number" formControlName="productQty" placeholder="Qty" min="0"
                                        class="w-full p-inputtext-sm" />
                                </span>
                                <p-button label="Add" (onClick)="addProduct()"
                                    [disabled]="!createOrderForm.controls.productCode.value || !createOrderForm.controls.productDescription.value || !createOrderForm.controls.productQty.value"
                                    [raised]="true" [size]="'small'" severity="info"></p-button>
                                <span style="margin-left: 10px;">
                                    <p-button icon="pi pi-trash" (onClick)="deleteProduct()"
                                        [disabled]="selectedProduct.length === 0" [raised]="true" [size]="'small'"
                                        severity="danger"></p-button>
                                </span>
                            </div>
                        </div>

                    </div> -->

                @if(selectedProduct.length > 0){
                <div class="field text-left">
                    <p-button icon="pi pi-trash" (onClick)="deleteProduct()" [disabled]="selectedProduct.length === 0"
                        [raised]="true" [size]="'small'" severity="danger"></p-button>
                </div>
                }
                <p-table #dt1 [value]="products" responsiveLayout="scroll" class="w-full m-5"
                    styleClass="p-datatable-sm" [rowHover]="true" [paginator]="true" [rows]="5"
                    [rowsPerPageOptions]="[5, 10, 20]" [paginator]="true" [(selection)]="selectedProduct">
                    <!-- (onEditComplete)="onProductEdit($event)"> -->
                    <ng-template pTemplate="header">
                        <tr>
                            <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                            <th>Sr No</th>
                            <th pSortableColumn="ProductCode">Code <p-sortIcon field="ProductCode"></p-sortIcon></th>
                            <th>Product Name </th>
                            <th>UOM </th>
                            <th></th>
                            <th>HSN/SAC</th>
                            <th>Order Qty</th>
                            <th>Shipped Qty</th>
                            <th class="text-right">Price(₹)</th>
                            <th class="text-right">Amount(₹)</th>
                            <th class="text-right">Disc(%)</th>
                            <th class="text-right">Net Amount(₹)</th>
                            <th>GST(%)</th>
                            <th class="text-right">GST(₹)</th>
                            <th class="text-right">Line Amount(₹) </th>
                            <th>Delivery Date</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-i="rowIndex">
                        <tr>
                            <td>
                                <p-tableCheckbox [value]="product"></p-tableCheckbox>
                            </td>
                            <td>{{i+1}}</td>
                            <td class="text-blue-500 underline" style="cursor: pointer;"
                                pEditableColumnField="ProductCode" (click)="viewProduct(product)">
                                {{ product.ProductCode }} </td>

                            <td>
                                <span *ngIf="product.ProductDescription.length > 20; else fullText">
                                    {{ product.ProductDescription }}
                                </span>
                                <ng-template #fullText>
                                    {{ product.ProductDescription }}
                                </ng-template>
                            </td>
                            <td>{{product.Uom}}</td>
                            <td><span class="text-lg cursor-pointer" (click)="showSpecification(product)"><i
                                        class="pi pi-flag-fill"></i></span></td>

                            <td>{{product.HSNCode}}</td>
                            <td>{{product.OrderQuantity}}</td>
                            <td [pEditableColumn]="product" pEditableColumnField="ShipedQuantity">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="number" min="0" (blur)="onProductEdit(product)"
                                            [(ngModel)]="product.ShipedQuantity" [ngModelOptions]="{ standalone: true }"
                                            (keydown)="onKeydown($event,product)" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ product.ShipedQuantity }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td class="text-right">{{ product.UnitPrice.toLocaleString('en-IN', { minimumFractionDigits:
                                2, maximumFractionDigits: 2}) }}</td>
                            <td class="text-right">{{product.ExtensionPrice.toLocaleString('en-IN', {
                                minimumFractionDigits: 2, maximumFractionDigits: 2})}} </td>
                            <td class="text-right">{{product.Discount?.toLocaleString('en-IN', {
                                minimumFractionDigits: 2, maximumFractionDigits: 2})}}%</td>
                            <!-- <td class="text-right" [pEditableColumn]="product" pEditableColumnField="Discount">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="number" class="p-inputtext-sm" min="0"
                                                [(ngModel)]="product.Discount" (keydown)="onKeydown($event, product)"
                                                (blur)="onProductEdit(product)" [ngModelOptions]="{ standalone: true }"
                                                [disabled]="isLineDiscountDisabled()" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{product.DiscountAmount?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
                                        </ng-template>
                                    </p-cellEditor>
                                </td> -->
                            <td class="text-right">{{product.NetAmount?.toLocaleString('en-IN', { minimumFractionDigits:
                                2, maximumFractionDigits: 2})}}</td>
                            <td>{{product.GSTRate}}%</td>
                            <td class="text-right">{{ (product.SalesTax).toLocaleString('en-IN', {
                                minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            <td class="text-right">{{product.LineTotal?.toLocaleString('en-IN', { minimumFractionDigits:
                                2, maximumFractionDigits: 2})}}</td>
                            <td style="width: 130px;">
                                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy"
                                    (blur)="onProductEdit(product)" (keydown)="onKeydown($event, product)"
                                    [(ngModel)]="product.deliveryDate" [ngModelOptions]="{ standalone: true }"
                                    [style]="{ width: '120px' }" appendTo="body">
                                </p-calendar>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="grid" style="margin-left: 5%;">
                            <div class="col-5 md:col-8">
                                <div class="grid formgrid">

                                    <div class="field col-12 md:col-3">
                                        <label>
                                            Header Discount(₹)
                                            <i class="pi pi-info-circle"
                                                pTooltip="Line discounts are percentage-based. Header discount is a fixed amount applied when line discounts are not used."
                                                tooltipPosition="top" style="margin-left:5px; cursor:pointer;">
                                            </i>
                                        </label>
                                        <input type="text" pInputText class="w-full" formControlName="DiscountAmount"
                                            readonly>
                                        <!-- <div *ngIf="createOrderForm.get('DiscountAmount')?.hasError('exceedTotal')"
     style="color: red; font-weight: normal; font-size: 14px; margin-top: 4px;">
  Discount cannot be greater than order total.
</div> -->
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label>Freight Charges(₹)</label>
                                        <input type="text" pInputText class="w-full" formControlName="FreightTotal">
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label>Rate on Freight</label>
                                        <p-dropdown class="w-full" [options]="gstOptions" optionLabel="label"
                                            optionValue="value" placeholder="Select GST"
                                            formControlName="RateOnFreight">
                                        </p-dropdown>
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label>GST on Freight(₹)</label>
                                        <input type="text" pInputText class="w-full" formControlName="GSTOnFreight"
                                            readonly>
                                    </div>


                                </div>
                            </div>
                            <div class="col-12 md:col-4 flex flex-column align-items-end">

                                <div class="field">
                                    CGST : ₹
                                    {{CGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>

                                <div class="field">
                                    SGST : ₹
                                    {{SGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>

                                <div class="field">
                                    IGST : ₹
                                    {{IGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>

                                <div class="field">
                                    Taxable : ₹
                                    {{Taxable.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>
                                <div class="field">
                                    Final Taxable Amount : ₹
                                    {{FinalTaxableAmt.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>
                                <div class="hr-line w-full my-2"></div>

                                <div class="flex align-items-center">
                                    <div class="mr-2">
                                        Total Qty :
                                        <span>{{weightTotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}</span>
                                    </div>
                                    <div class="mx-2">|</div>
                                    <div>
                                        Total : ₹
                                        <span>{{orderTotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </ng-template>
                </p-table>

            </p-tabPanel>

            <p-tabPanel header="Dispatch  Details">

                <div class="grid">


                    <div class="col">


                        <div class="field text-left">
                            <label>Motor Vehical No.</label>
                            <input type="text" formControlName="MotorVehicalNo" pInputText class="w-full" />
                        </div>

                        <div class="field text-left">
                            <label>Dispatch Doc No.</label>
                            <input type="text" formControlName="DispatchDocNo" pInputText class="w-full" />
                        </div>

                        <div class="field text-left">
                            <label for="TermsCode">Payment Terms</label>
                            <div class="p-inputgroup p-lookup">
                                <input pInputText formControlName="TermsCode" readonly class="w-full"
                                    (keydown)="onKeydown($event,products)" />
                                <button type="button" pButton pRipple (click)="showTermsCode()" icon="pi pi-search"
                                    styleClass="p-button-warn"></button>
                            </div>
                        </div>
                        <div class="field text-left">
                            <label for="ReferenceNumber">Reference Number</label>
                            <input type="text" formControlName="ReferenceNumber" pInputText class="w-full"
                                (keydown.enter)="focusNextInput($event)" />
                        </div>
                        <div class="field text-left">
                            <label for="Destination">Destination</label>
                            <input type="text" formControlName="Destination" pInputText class="w-full"
                                (keydown.enter)="focusNextInput($event)" />
                        </div>

                        <div class="field text-left">
                            <label for="projectName">Project Name</label>
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                                <input pInputText formControlName="projectName" readonly placeholder="Select Project" style="width: 200px;" />
                                <p-button icon="pi pi-search" (click)="getProjectLookup()" [raised]="true" [size]="'small'" severity="info"
                                    [disabled]="canEdit"></p-button>
                                <button *ngIf="createOrderForm.get('projectName')?.value" type="button" pButton pRipple icon="pi pi-times"
                                    class="p-button-danger" severity="danger" (click)="clearProject()" title="Clear Project"
                                    [disabled]="canEdit"></button>
                            </div>
                        </div>

                    </div>

                    <div class="col">


                        <div class="field text-left">
                            <label>Expected Dispatch Date</label>
                            <p-calendar [iconDisplay]="'input'" formControlName="ShipmentDate" dateFormat="dd/mm/yy"
                                styleClass="w-full" [showIcon]="true"></p-calendar>
                        </div>

                        <div class="field text-left">
                            <label>Bill Of Lading / LR-RR No</label>
                            <input type="text" formControlName="BillOfLading" pInputText class="w-full" />
                        </div>
                        <div class="field text-left">
                            <label>Customer PO Number</label>
                            <input type="text" formControlName="purchaseOrderNumber" pInputText class="w-full"
                                (keydown)="onKeydown($event,products)" />
                        </div>
                        <div class="field text-left">
                            <label>Customer PO Date</label>
                            <p-calendar [iconDisplay]="'input'" formControlName="CustomerPODate" dateFormat="dd/mm/yy"
                                styleClass="w-full" [showIcon]="true"
                                (keydown.enter)="focusNextInput($event)"></p-calendar>
                        </div>
                        <div class="field text-left">
                            <label for="TermsOfDelivery">Terms Of Delivery</label>
                            <textarea rows="3" pInputTextarea formControlName="TermsOfDelivery"
                                class="w-full"></textarea>
                        </div>
                    </div>

                    <div class="col">

                        <div class="field text-left">
                            <label>Dispatch Through</label>
                            <input type="text" formControlName="DispatchThrough" pInputText class="w-full" />
                        </div>

                        <div class="field text-left">
                            <label>Driver Name</label>
                            <input type="text" formControlName="driverName" pInputText class="w-full" />
                        </div>

                        <div class="field text-left">
                            <label>Driver Contact</label>
                            <span class="p-float-label">
                                <input pInputText formControlName="driverContact" class="w-full"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.driverContact.errors }" />
                                <small *ngIf="submitted && formControls.driverContact.errors?.['pattern']"
                                    id="name-error" class="text-red-500">Invalid
                                    driverContact number. Please enter 10-digit mobile number.</small>
                            </span>
                        </div>

                        <div class="field text-left">
                            <label>Expected Delivery Date</label>
                            <p-calendar [iconDisplay]="'input'" formControlName="expDeliveryDate" dateFormat="dd/mm/yy"
                                styleClass="w-full" [showIcon]="true"
                                (keydown.enter)="focusNextInput($event)"></p-calendar>
                        </div>

                        <!-- <div class="field text-left">
                                <label>LR-RR No.</label>
                                <input type="text" formControlName="LRRRNo" pInputText class="w-full p-inputtext-sm" />
                            </div> -->

                        <div class="field text-left">
                            <label for="deliveryNote">Delivery Note</label>
                            <textarea rows="3" pInputTextarea formControlName="deliveryNote" class="w-full"></textarea>
                        </div>

                    </div>

                </div>

            </p-tabPanel>

        </p-tabView>

    </form>

</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<p-dialog header="Credit Limit Exceeded" [(visible)]="creditLimitExceeded" [modal]="true" [closable]="false"
    styleClass="w-40rem" [style]="{minWidth: '400px'}">
    <div class="p-mb-4">
        <h3 class="text-danger" style="margin-bottom: 0;">
            Credit limit has exceeded by <strong>{{ exceededAmount | currency:'INR':'symbol-narrow' }}</strong>
        </h3>
        <p class="mt-1">You cannot create this invoice as the customer's credit limit has exceeded the set value.</p>
    </div>

    <button type="button" class="p-link p-mb-3" (click)="toggleDetails($event)"
        style="padding:0; border:none; background:none; cursor:pointer; color: blue; text-decoration: underline;">
        {{ showCreditDetails ? 'Hide Details' : 'View Details' }}
        <i class="pi" [ngClass]="{'pi-angle-up': showCreditDetails, 'pi-angle-down': !showCreditDetails}"
            style="margin-left: 0.5rem;"></i>
    </button>

    <div *ngIf="showCreditDetails" class="p-mt-3"
        style="max-height: 200px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 4px; padding: 1rem; background: #f9f9f9;">
        <table class="p-datatable-table" style="width: 100%; font-size: 0.95rem;">
            <tbody>
                <tr>
                    <td>Outstanding Receivables</td>
                    <td class="text-right font-weight-bold">{{ totalOutstanding | currency:'INR':'symbol-narrow' }}</td>
                </tr>
                <tr>
                    <td>Invoice Amount</td>
                    <td class="text-right font-weight-bold">{{ invoiceAmount | currency:'INR':'symbol-narrow' }}</td>
                </tr>
                <tr>
                    <td colspan="2">
                        <hr class="p-mb-2 p-mt-2" />
                    </td>
                </tr>
                <tr>
                    <td><strong>Total Outstanding Receivables</strong></td>
                    <td class="text-right font-weight-bold">{{ (totalOutstanding + orderTotal) |
                        currency:'INR':'symbol-narrow' }}</td>
                </tr>
                <tr>
                    <td>Customer Credit Limit</td>
                    <td class="text-right font-weight-bold">{{ customerCreditLimit | currency:'INR':'symbol-narrow' }}
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <hr class="p-mb-2 p-mt-2" />
                    </td>
                </tr>
                <tr>
                    <td><strong class="text-danger">Exceeded Amount</strong></td>
                    <td class="text-right text-danger font-weight-bold">{{ exceededAmount |
                        currency:'INR':'symbol-narrow' }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <ng-template pTemplate="footer">
        <button *ngIf="!showCreditDetails" pButton label="OK" icon="pi pi-check" (click)="closeCreditDialog()"
            class="p-button-primary"></button>
        <ng-container *ngIf="showCreditDetails">
            <button pButton label="Proceed" icon="pi pi-check" (click)="continueInvoiceCreation()"
                class="p-button-success"></button>
            <button pButton label="Cancel" icon="pi pi-times" (click)="closeCreditDialog()"
                class="p-button-primary"></button>
        </ng-container>
    </ng-template>

</p-dialog>

<p-dialog header="Update Options" [(visible)]="savePopupVisible" [modal]="true" [closable]="true"
    [dismissableMask]="true" (onHide)="onSavePopupHide()">
    <div class="flex gap-2">
        <p-button label="Update" icon="pi pi-save" (click)="updateOnly()"></p-button>
        <p-button label="Update & Send" icon="pi pi-send" (click)="updateAndSend()"></p-button>
    </div>
</p-dialog>